import InsertTeachingPeriodForm from './InsertTeachingPeriodForm';
export default InsertTeachingPeriodForm;
